import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';

import { CircleBtnComponent } from '@shared/core/components/buttons';

@Component({
    selector: 'shared-selector',
    templateUrl: './selector.shared.component.html',
    styleUrls: ['./selector.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectorComponent extends CircleBtnComponent implements OnInit {
    @Input() public selected: boolean = false;
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public feelDeselected: OLO.Components.BUTTON_CIRCLE_FEEL = 'positive-secondary';
    @Input() public feelSelected: OLO.Components.BUTTON_CIRCLE_FEEL = 'positive-full';
    @Input() public iconDeselected: string = 'plus';
    @Input() public iconSelected: string = 'checkmark';

    @Output() public onSelected: EventEmitter<Event> = new EventEmitter();
    @Output() public onDeselected: EventEmitter<Event> = new EventEmitter();

    constructor(
        public renderer2: Renderer2,
        public elementRef: ElementRef,
        public changeDetectorRef: ChangeDetectorRef
    ) {
        super(renderer2, elementRef, changeDetectorRef);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    public handleSelected($event: Event): void {
        this.onSelected.emit($event);

        this.changeDetectorRef.markForCheck();
    }

    public handleDeselected($event: Event): void {
        this.onDeselected.emit($event);

        this.changeDetectorRef.markForCheck();
    }

    public get isSelected(): boolean {
        return this.selected;
    }

}
